import { z } from 'zod';
import { AlertSchema, NOTIFICATION_CHANNELS } from './alerts.js';
/**
 * Notification delivery, TechSpec §12.3 (step 32, PRD VS-061). The API decides
 * what to deliver (channels of the rule, cooldown, quiet hours) and tells the
 * clients over SSE; the web shows in-app toasts and asks the platform for a
 * native notification; Telegram is sent server-side with retries.
 */
/** Why a notification went out. `fired` is subject to the rule's cooldown; the others always notify. */
export const NOTIFY_REASONS = ['opened', 'fired', 'unsnoozed'];
const HHMM = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'HH:MM');
/** Local-time window in `timezone`; `start > end` spans midnight. Suppresses desktop and Telegram, never in-app. */
export const QuietHoursSchema = z.object({
    enabled: z.boolean(),
    start: HHMM,
    end: HHMM,
});
export const NotificationSettingsSchema = z.object({
    quietHours: QuietHoursSchema,
    /** IANA zone the quiet hours are read in. */
    timezone: z.string().min(1).max(64),
});
export const DEFAULT_NOTIFICATION_SETTINGS = {
    quietHours: { enabled: false, start: '22:00', end: '07:00' },
    timezone: 'Europe/Paris',
};
/** `GET /settings/notifications`: the settings plus what the server can deliver. */
export const NotificationSettingsResponseSchema = z.object({
    settings: NotificationSettingsSchema,
    telegram: z.object({ configured: z.boolean() }),
});
/** `POST /notifications/test`: sends one test message over the channel; 409 when not configured, 502 when it fails. */
export const NotificationTestRequestSchema = z.object({ channel: z.literal('telegram') });
/** SSE `alert.notified`: delivered channels only; the web toasts on `in-app` and calls the platform on `desktop`. */
export const AlertNotifiedMessageSchema = z.object({
    alert: AlertSchema,
    channels: z.array(z.enum(NOTIFICATION_CHANNELS)).min(1),
    reason: z.enum(NOTIFY_REASONS),
});
//# sourceMappingURL=notifications.js.map